import RemarksConfirmModal from "../../LessonPlanner/components/RemarksConfirmModal";

/** Teacher submits their weekly diary for approval; the reflection is required. */
const SubmitDiaryModal = ({ isOpen, subjectName, weekLabel, initialReflection, isSubmitting, onClose, onSubmit }) => (
  <RemarksConfirmModal
    isOpen={isOpen}
    title="Submit Diary"
    message={
      <>
        You&apos;re about to submit your <strong>{subjectName}</strong> diary for <strong>“{weekLabel}”</strong> for
        approval. Add your weekly reflection below.
      </>
    }
    label="Weekly Reflection"
    placeholder="What went well, challenges faced, student observations, topics needing revisit and your plan for next week..."
    initialValue={initialReflection}
    required
    requiredMessage="Weekly reflection is required"
    isSubmitting={isSubmitting}
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

export default SubmitDiaryModal;
